import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["children", "components", "placeholderResolver"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as e } from "react/jsx-runtime";
import { mergeComponents as i, PortableTextComponentsProvider as s } from "@portabletext/react";
import C, { useMemo as p } from "react";
import { defaultComponents as c } from "./components.js";
const a = _ref => {
    let {
        children: n,
        components: t,
        placeholderResolver: o
      } = _ref,
      r = _objectWithoutProperties(_ref, _excluded);
    const m = p(() => i(c(o), t), [t, o]);
    return /* @__PURE__ */e(d.Provider, {
      value: o,
      children: /* @__PURE__ */e(s, _objectSpread(_objectSpread({}, r), {}, {
        components: m,
        children: n
      }))
    });
  },
  d = /* @__PURE__ */C.createContext(void 0);
export { a as BlockContentComponentsProvider, d as BlockContentPlaceholderResolverContext };